import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
import SingleCsvReportDownload from '../DownloadReport/SingleCsvReportDownload.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import MerchantFilter from '../../filters/MerchantFilter2.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import TxnTypeFilter from '../../filters/TxnTypeFilter1.jsx';
import SettledUnsettledFilter from '../../filters/settled_unsettledFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import CityFilter from '../../filters/CityFilter.jsx';
import IndustryCategoryFilter from '../../filters/IndustryCategoryFilter.jsx';
import PosbillFilter from '../../filters/PosbillFilter.jsx';
import PrimIdFilter from '../../filters/PrimIdFilter.jsx';
import GSTFilter from '../../filters/GSTFilter.jsx';
import CardNumberFilter from '../../filters/CardNumberFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var date_config = date_range_config('1', '1', '2020-02-01','1');
var date_config1 = date_range_config('0', '0', '2020-02-01','0');
var UpiPayTraTable='';

class UpiPayTransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            txnTypeLists: [],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            isSettledLists: [],
            isSettledIDs: '',
            isSettledValue: null,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            gst_columns:0,
            fetch_data:false,
            ci_mask_card_number:0,
            industryCategoryList:[],
            industryCategoryValue: null,
            industryCategoryIds:'',
            is_current_date: 'yes'
        }
//         this.close = this.close.bind(this);
//         this.closeStoreList = this.closeStoreList.bind(this);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'upi_transaction');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }

    componentDidUpdate() {

    }
    componentDidMount() {
    this._get_filtered_upi_transaction_report(this.state.object_type,this.state.object_code,'');
    user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'upi_txn_report','sparcs')
}
    _get_filtered_upi_transaction_report(object_type, object_code, event) {
        var that = this;
        var corCol = 'Merchant';
        var ufeCol = 'Merchant';
        var CI_Time = 'Merchant'; var BI_Time = 'Merchant'; var BO_Time = 'Merchant'; var CO_Time = 'Merchant';
        if(this.state.userType==='Internal') {
            CI_Time = 'CI Time'; BI_Time = 'BI Time'; BO_Time = 'BO Time'; CO_Time = 'CO Time';
        }
        if(that.state.txnTypeIDs.includes("FAILED")===true || that.state.txnTypeIDs.includes("all")===true) {
            corCol = 'Co Reason Message';
            ufeCol = 'Ufe Message';
        }
        var pos_order_id = 'Merchant';
        var grab_order_id = 'Merchant';
        var grab_client_id = 'Merchant';
        var pos_merchant = 'Merchant';
        if(that.state.is_posbillinput==1){
            grab_order_id = 'Grab Order ID';
            pos_order_id = 'Pos Order ID';
            grab_client_id = 'Grab Client ID';
            pos_merchant = 'Pos Merchant ID';
        }
        let GST = 'Merchant';
        let CGST = 'Merchant';
        let SGST = 'Merchant';
        let IGST = 'Merchant';
        let CESS = 'Merchant';
        let GST_Number = 'Merchant';
        let Invoice_No = 'Merchant';
        let Invoice_Date = 'Merchant';
        let Invoice_Amount = 'Merchant';
        if(that.state.gst_columns==1){
            GST = 'GST';
            CGST = 'CGST';
            SGST = 'SGST';
            IGST = 'IGST';
            CESS = 'CESS';
            GST_Number = 'GST Number';
            Invoice_No = 'GST Invoice No';
            Invoice_Date = 'GST Invoice Date';
            Invoice_Amount = 'GST Invoice Amount';
        }
        let card_no_col = 'Merchant';
        if(that.state.ci_mask_card_number ==1){
             card_no_col = 'Card Number';
        }
        isApiResponse(false)
//         disabledBody()
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        this.setState({
            active_mids: merchants,
            active_cids: chains,
            active_sids: stores,
            active_bids: this.state.acqBankIds,
            active_cityids: this.state.cityIds,
            active_transaction_type: this.state.txnTypeIDs,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
            active_utid: this.state.ciutidIds,
            active_is_settled: this.state.isSettledIDs,
            active_is_prim_id: this.state.is_prim_id,
            active_is_posbillinput: this.state.is_posbillinput,
        })
    var yestSend = date_config1.start_date_value;
        var todSend = date_config1.end_date_value;
        if(this.state.is_current_date=='no') {
            yestSend = this.state.yestSend;
            todSend = this.state.todSend;
        }
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: yestSend,
            todSend: todSend,
            is_void: this.state.is_void,
            txn_type: 'UPI',
            transaction_type: this.state.txnTypeIDs,
            utid: this.state.ciutidIds,
            is_settled: this.state.isSettledIDs,
            is_posbillinput: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            gst_columns: this.state.gst_columns,
            ci_mask_card_number: this.state.ci_mask_card_number,
            industry_code: this.state.industryCategoryIds,
            userType: this.state.userType,
            is_current_date: this.state.is_current_date
        };
        if ($.fn.DataTable.isDataTable('#UpiPayTraTable')) {
            $('#UpiPayTraTable').DataTable().clear().destroy();
        }
        var UpiPayTraTable = $('#UpiPayTraTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                //"autoWidth": false,
                "sPaginationType": "numbers",
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/transaction-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                        
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                       isApiResponse(true);
                       alert("Failed to load data. Please try again");
                       console.log("error", data);
                    },
                    complete: function (data) {
                        isApiResponse(true);
                    },
                },

                columns: [
                    {"data":"Store VPA"},
                    {"data":"Merchant" },
                    {"data":"Chain"},
                    {"data":"Store"},
                    {"data":"Store Address 1"},
                    {"data":"Store Address 2"},
                    {"data":"City"},
                    {"data":"State"},
                    {"data":"Customer VPA"},
                    {"data":"Utid"},
                    {"data":"Btid"},
                    {"data":"Acquirer Bank"},
                    {"data":"UPI Account Type"},
                    {"data":"Invoice Number"},
                    {"data":"UPI Transaction Id"},
                    {"data":"RRN Number"},
                    {"data":"Approval Code"},
                    {"data":"Tender Mode"},
                    {"data":"Transaction Date"},
                    {"data":"Transaction Time"},
                    {"data":"Bill Number"},
                    {"data":"Mobile Number"},
                    {"data":"Transaction Type"},
                    {"data":"Front End App Version"},
                    {"data":"Invoice Amount"},
                    {"data":"Debit Amount"},
                    {"data":"Customer Reference No"},
                    {"data":"Settlement Date"},
                    {"data":"Settled/Unsettled"},
                    {"data":corCol},
                    {"data":ufeCol},
                    {"data":grab_order_id },
                    {"data":pos_order_id },
                    {"data":grab_client_id },
                    {"data":pos_merchant },
                    {"data":"prim_id" },
                    {"data":"parent_prim_id"},
                    {"data":GST},
                    {"data":CGST},
                    {"data":SGST },
                    {"data":IGST },
                    {"data":CESS },
                    {"data":GST_Number },
                    {"data":Invoice_No },
                    {"data":Invoice_Date },
                    {"data":Invoice_Amount },
                    {"data":card_no_col },
                    {"data":"Industry Category"},
                    {"data":CI_Time },
                    {"data":BI_Time },
                    {"data":BO_Time },
                    {"data":CO_Time }
                ],
                "columnDefs": [
                    {
                        width: "130px",
                        targets: 1,
                    },
                    {
                        width: "100px",
                        targets: 2,
                    },
                    {
                        width: "100px",
                        targets: 3,
                    },
                    {
                        width: "130px",
                        targets: 14,
                    },
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2,3,4,5]
                    },
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY')+'</td>';
                        },
                        "width": "80px",
                        "targets": 43
                    },


                ]
            });
        if(that.state.userType==='Internal') {
            UpiPayTraTable.columns(48).visible(true);
            UpiPayTraTable.columns(49).visible(true);
            UpiPayTraTable.columns(50).visible(true);
            UpiPayTraTable.columns(51).visible(true);
        } else {
            UpiPayTraTable.columns(48).visible(false);
            UpiPayTraTable.columns(49).visible(false);
            UpiPayTraTable.columns(50).visible(false);
            UpiPayTraTable.columns(51).visible(false);
        }
        if(that.state.txnTypeIDs.includes("FAILED")===true || that.state.txnTypeIDs.includes("all")===true) {
            UpiPayTraTable.columns(29).visible(true);
            UpiPayTraTable.columns(30).visible(true);
        } else {
            UpiPayTraTable.columns(29).visible(false);
            UpiPayTraTable.columns(30).visible(false);
        }
        if(that.state.is_posbillinput===1) {
            UpiPayTraTable.columns(31).visible(true);
            UpiPayTraTable.columns(32).visible(true);
            UpiPayTraTable.columns(33).visible(true);
            UpiPayTraTable.columns(34).visible(true);

        } else {
            UpiPayTraTable.columns(31).visible(false);
            UpiPayTraTable.columns(32).visible(false);
            UpiPayTraTable.columns(33).visible(false);
            UpiPayTraTable.columns(34).visible(false);

        }
        if(that.state.is_prim_id===1) {
            UpiPayTraTable.columns(35).visible(true);
            if(that.state.txnTypeIDs.includes("REVERSAL")===true || that.state.txnTypeIDs.includes("VOID")===true || that.state.txnTypeIDs.includes("FAILED")===true|| that.state.txnTypeIDs.includes("all")===true) {
                UpiPayTraTable.columns(36).visible(true);
            } else {
                UpiPayTraTable.columns(36).visible(false);
            }
        } else {
            UpiPayTraTable.columns(35).visible(false);
            UpiPayTraTable.columns(36).visible(false);
        }
        if(that.state.gst_columns===1) {
            UpiPayTraTable.columns(37).visible(true);
            UpiPayTraTable.columns(38).visible(true);
            UpiPayTraTable.columns(39).visible(true);
            UpiPayTraTable.columns(40).visible(true);
            UpiPayTraTable.columns(41).visible(true);
            UpiPayTraTable.columns(42).visible(true);
            UpiPayTraTable.columns(43).visible(true);
            UpiPayTraTable.columns(44).visible(true);
            UpiPayTraTable.columns(45).visible(true);

        } else {
            UpiPayTraTable.columns(37).visible(false);
            UpiPayTraTable.columns(38).visible(false);
            UpiPayTraTable.columns(39).visible(false);
            UpiPayTraTable.columns(40).visible(false);
            UpiPayTraTable.columns(41).visible(false);
            UpiPayTraTable.columns(42).visible(false);
            UpiPayTraTable.columns(43).visible(false);
            UpiPayTraTable.columns(44).visible(false);
            UpiPayTraTable.columns(45).visible(false);

        }

        if(that.state.ci_mask_card_number ==1){
            UpiPayTraTable.columns(46).visible(true);
        }
        else {
            UpiPayTraTable.columns(46).visible(false);
        }
    }
    filterList(e){

        var value = e.target.value
        setTimeout(function() {
            this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, true, value);
        }.bind(this), 200);
    }
    toggleList() {
        this.setState({
            listOpen: !this.state.listOpen,
        });
    }
    transactionReportDownloadCheck(){
        let transaction_type = this.state.txnTypeIDs;
        if (Array.isArray(this.state.txnTypeIDs) && this.state.txnTypeIDs.includes("all") === true) {
            transaction_type = ""
        }
    var yestSend = date_config1.start_date_value;
        var todSend = date_config1.end_date_value;
        if(this.state.is_current_date=='no') {
            yestSend = this.state.yestSend;
            todSend = this.state.todSend;
        }
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            utid: this.state.ciutidIds,
            acq_bank_codes: this.state.acqBankIds,
            city: this.state.cityIds,
            transaction_type: transaction_type,
            settlement_status: this.state.isSettledIDs,
            show_pos_bill_input_columns: this.state.is_posbillinput,
            show_txn_prim_id: this.state.is_prim_id,
            start_date: yestSend,
            end_date: todSend,
            show_void_transactions: this.state.is_void,
            txn_type: 'UPI',
            category_code: this.state.industryCategoryIds,
            download: 1,
            gst_columns: this.state.gst_columns,
            ci_mask_card_number: this.state.ci_mask_card_number,
            user_type: this.state.userType,
            report_code:"upi_txn_report",
            user_id: this.state.user_id,
            is_current_date: this.state.is_current_date

        }
        this.setState({
            filters:filters
        })
        let is_txn = false;
        if(this.state.txnTypeIDs.length===1 && this.state.txnTypeIDs[0]==='SALE')
        {
           is_txn = true;
        }
        if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds==='' && this.state.acqBankIds===''
        && this.state.cityIds==='' && this.state.traCurrencyIDs==='' && this.state.txnissuerIDs==='' && this.state.schemeIDs===''
        && this.state.cardTypeIDs==='' && this.state.isSettledIDs==='' && this.state.issuHomeCurrIDs==='' && is_txn ===true
        ){
          confirmAlert({
                //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/report/transaction/daily/categories','upi_transaction_report');
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
            } else {
                this.refs.downloadAllReport.downLoadReport(filters, '/report/transaction/daily/categories','upi_transaction_report');
            }
    }

     handlePosBill = (is_posbillinput) => {
        this.setState({is_posbillinput: is_posbillinput, isChange: true});
    }
    handlePrimId = (is_prim_id) => {
        this.setState({is_prim_id: is_prim_id, isChange: true});
    }
    handleGst = (gst_columns) => {
        this.setState({gst_columns: gst_columns, isChange: true});
    }
    handleCardNo = (ci_mask_card_number) => {
        this.setState({ci_mask_card_number: ci_mask_card_number, isChange: true});
    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }
    handleTxnType = (optionSelected, txnTypeIDs) =>
    {
        this.setState({
            txnTypeIDs:txnTypeIDs,
            txnTypeValue:optionSelected,
            isChange: true
        });
    }
    handleSettled = (optionSelected, isSettledIDs) =>
    {
        this.setState({
            isSettledIDs:isSettledIDs,
            isSettledValue:optionSelected,
            isChange: true
        });
    }
    handleCity = (optionSelected, cityIds) =>
    {
        this.setState({
            cityIds:cityIds,
            isChange: true
        });
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleIndustryCategoryFilter = (optionSelected, industryCategoryIds) =>
    {
        this.setState({
            industryCategoryIds:industryCategoryIds,
            isChange: true
        });
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
//         this.refs.reloadTxnIssuer._txn_issuer_bank(yestSend, todSend);
//         this.refs.cardTypeFilter._get_card_type(yestSend, todSend);
//         this.refs.txnCurrencyFilter._get_txn_curr(yestSend, todSend);
//         this.refs.homeCurrencyFilter._get_home_curr(yestSend, todSend);

    }

    reset_all(e){
          if(this.state.is_current_date=='no'){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        }
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        this.refs.txnTypeFilter.resetTxnTypeFilter();
        this.refs.settledFilter.resetSettledFilter();
        this.refs.cityFilter.resetCityFilter();
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.refs.industryCategoryFilter.resetIndustryCategoryFilter();
        this.refs.posbillFilter.resetPosbillFilter();
        this.refs.primIdFilter.resetPrimIdFilter();
        this.refs.gSTFilter.resetGSTFilter();
        this.refs.cardNumberFilter.resetCardNumberFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            tenderModeValue:[],
            is_fallback: 0,
            traCurrencyValue:[],
            traCurrencyIDs:'',
            issuHomeCurrValue:[],
            issuHomeCurrIDs:'',
            campaignCodeValue:[],
            campaignCodeIDs:'',
            gst_columns:0,
            ci_mask_card_number: 0,
            industryCategoryIds:'',
            industryCategoryValue: [],
            ci_mask_card_number:0,
            is_current_date:'yes'
        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()

        }.bind(this), 200);
    }
    onDateTypeChanged = e => {
        const {name, value} = e.target;
        this.setState({
            [name]: value,
            isChange: true,

        });

    }
    render() {
        return(
           
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">UPI Transaction Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content" style={{ padding: '0px 15px 10px 15px' }}>
                                    <div className="row">
                                        <div className="col-md-10 filter-border-right">
                                            <div>
                                                <label><input type="radio" name="is_current_date"
                                                                   value="yes"
                                                                   checked={this.state.is_current_date === 'yes'}
                                                                   onChange={this.onDateTypeChanged} /> Current Date
                                                                   &nbsp;&nbsp;&nbsp;&nbsp;<input type="radio" name="is_current_date"
                                                                   value="no"
                                                                   checked={this.state.is_current_date === 'no'}
                                                                   onChange={this.onDateTypeChanged} /> Previous Date</label>

                                                </div>
                                                <div className="clearfix"></div>
                                                {this.state.is_current_date==='no'?
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                        </div>:null}
                                    {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            {/*{this.state.acq_bank_list_box===true?*/}
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Acquirer:</label>
                                           <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                                <div className="clearfix"></div>
                                        </div>
                                    {/*: null }*/}

                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> City: </label>
                                            <CityFilter ref="cityFilter" onSelectCity = {this.handleCity}/>
                                                <div className="clearfix"></div>
                                        </div>

                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Txn Type </label>
                                        <TxnTypeFilter ref="txnTypeFilter" onSelectTxnType = {this.handleTxnType} is_upi_leg1 = 'No'  is_dcc_sale_leg1='No'/>
                                                <div className="clearfix"></div>
                                                <div className="clearfix"></div>
                                                <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Settled/Unsettled </label>
                                        <SettledUnsettledFilter ref="settledFilter" onSelectSettled = {this.handleSettled}/>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Industry Category: </label>
                                                <IndustryCategoryFilter ref="industryCategoryFilter" onSelectIndustryCategoryFilter = {this.handleIndustryCategoryFilter}/>
                                                <div className="clearfix"></div>
                                            </div>

                                        </div>
                                        <div className="col-md-2 filter-bottom5 ">
                                            <div>
                                                <PosbillFilter ref="posbillFilter" onSelectPosbill = {this.handlePosBill} />
                                            </div>
                                            <div>
                                                <PrimIdFilter ref="primIdFilter" onSelectPrimId = {this.handlePrimId} />
                                            </div>
                                           <div>
                                            <GSTFilter ref="gSTFilter" onSelectGST = {this.handleGst} />
                                           </div>

                                           <div>
                                            <CardNumberFilter ref="cardNumberFilter" onSelectCardNumber = {this.handleCardNo} />
                                           </div>

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                        <button type="button" className="apply-filter" role="button" disabled={!this.state.isChange} onClick={this._get_filtered_upi_transaction_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                    </div>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.transactionReportDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="UpiPayTraTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Store VPA</th>
                                                    <th width="100px">Merchant</th>
                                                    <th width="100px">Chain</th>
                                                    <th width="75px">Store</th>
                                                    <th width="150px">Store Address 1</th>
                                                    <th>Store Address 2</th>
                                                    <th>City</th>
                                                    <th>State</th>
                                                    <th>Customer VPA</th>
                                                    <th>UTID</th>
                                                    <th>BTID</th>
                                                    <th>Acquirer Bank</th>
                                                    <th>UPI Account Type</th>
                                                    <th>Invoice Number</th>
                                                    <th>UPI Transaction Id</th>
                                                    {/*<th>Order Id</th>*/}
                                                    <th>RRN Number</th>
                                                    <th>Approval Code</th>
                                                    <th>Ci_tender_mode</th>
                                                    <th>Transaction Date</th>
                                                    <th>Transaction Time</th>
                                                    <th>Bill Number</th>
                                                    <th>Mobile Number</th>
                                                    <th>Transaction Type</th>
                                                    <th>Front End App Version</th>
                                                    <th>Invoice Amount</th>
                                                    <th>Debit Amount</th>
                                                    <th>Customer Reference No</th>
                                                    <th>Settlement Date</th>
                                                    <th>Settled/Unsettled</th>
                                                    <th>Co Reason Message</th>
                                                    <th>Ufe Message</th>
                                                    <th>Grab Order ID</th>
                                                    <th>Pos Order ID</th>
                                                    <th>Grab Client ID</th>
                                                    <th>Pos Merchant ID</th>
                                                    <th>Prim ID</th>
                                                    <th>Parent Prim ID</th>

                                                    <th>GST</th>
                                                    <th>CGST</th>
                                                    <th>SGST </th>
                                                    <th>IGST</th>
                                                    <th>CESS</th>
                                                    <th>GST Number</th>
                                                    <th>GST Invoice No</th>
                                                    <th>GST Invoice Date</th>
                                                    <th>GST Invoice Amount</th>
                                                    <th>Card Number</th>
                                                    <th>Industry Category</th>
                                                    <th>CI Time</th>
                                                    <th>BI Time</th>
                                                    <th>BO Time</th>
                                                    <th>CO Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                         <SingleCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
     
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( UpiPayTransactionReport )